import { useEffect, useMemo } from 'react';
import { useAccommodationsConsoleSearchParamsHelper } from '../useAccommodationsConsoleSearchParamsHelper';
import { SORT_QUERY_PARAM_KEY } from './constants';
import { useUpdateAccommodationsConsoleSearchParams } from './useUpdateAccommodationsConsoleSearchParams';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import type { SortOption } from '@shared/constants/accommodations';

export const useListingsSortQueryParam = (defaultSortOption: SortOption) => {
  const queryParamHelper = useAccommodationsConsoleSearchParamsHelper();
  const { applyAccommodationConsoleSearchParamsToUrl } = useUpdateAccommodationsConsoleSearchParams();

  // Set default sort in URL if not present
  useEffect(() => {
    if (!queryParamHelper.getValueString(SORT_QUERY_PARAM_KEY)) {
      applyAccommodationConsoleSearchParamsToUrl({
        searchParams: { [SORT_QUERY_PARAM_KEY]: defaultSortOption },
        actionType: 'replace',
      });
    }
  }, [queryParamHelper, applyAccommodationConsoleSearchParamsToUrl, defaultSortOption]);

  const currentSort: SortOption = useMemo(() => {
    return (queryParamHelper.getValueString(SORT_QUERY_PARAM_KEY) as Maybe<SortOption>) || defaultSortOption;
  }, [queryParamHelper, defaultSortOption]);

  const updateSort = useEventCallback((newSort: string | null) => {
    applyAccommodationConsoleSearchParamsToUrl({
      searchParams: {
        [SORT_QUERY_PARAM_KEY]: newSort,
      },
      actionType: 'replace',
    });
  });

  return {
    currentSort,
    updateSort,
  };
};
